// extracted by mini-css-extract-plugin
module.exports = {"container":"_1M5JgNo0gLIJ3G_lhjSF_k","item":"_3a4bQJXVQRvUbiK0MGkkKa","description":"_1rgJqZtV-deZdOl0D_544o"};